import ProductListState from './states/ProductListState';

export default {
  'ruko/states/ProductListState': ProductListState,
}
